"use client";
import React from "react";
import { ResourceDownloadable } from "../resource-downloadable";
import { ResourceContentGrid } from "../resource-content-grid";
import { useSearchParams } from "next/navigation";

export const ResourceContent = ({ featuredAsset, allResourcesData }) => {
  const searchParams = useSearchParams();

  return (
    <div className="col-span-1 md:col-span-3">
      {!searchParams.get("search") && featuredAsset && (
        <ResourceDownloadable featuredAsset={featuredAsset} />
      )}
      <ResourceContentGrid allResourcesData={allResourcesData} />
    </div>
  );
};
